import { app } from '../../../../../app';
import { Controller } from './unshare-shared-accounts.controller';

app.component('companyUserDirectoriesManageUserUnshareSharedAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        userSharedServiceAccounts: '<',
        userSharedNotes: '<',
        companyId: '<',
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./unshare-shared-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.component.js